import { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CMM } from '../../Lib/Cmm.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Header from "components/Headers/Header.js";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";

let maxPageNo;

const Answer = () => {
  const [data, setData] = useState([]);

  const [question, setQuestion] = useState('');
  const [newAnswer, setNewAnswer] = useState('');
  const [newUrl, setNewUrl] = useState('');
  const [newUrlText, setNewUrlText] = useState('');

  const [viewNo, setViewNo] = useState(3);
  const [selectNo, setSelectNo] = useState(1);
  const [search, setSearch] = useState('');

  //데이터 가져오기
  useEffect(() => {

    lodeData();
    dataCnt();

  }, []);

  useEffect(() => {
    lodeData();
    dataCnt();
  }, [selectNo]);

  useEffect(() => {
    lodeData();
    dataCnt();
  }, [search]);

  //채팅방 개수
  const dataCnt = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_list_cnt`,
      {
        srch: search,
      })
      .then((res) => {
        if (res != 'ERROR') {
          console.log(res);

          var roomCnt = res[0].totalRows;
          maxPageNo = Math.ceil(roomCnt / 10);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [search, maxPageNo]);

  //데이터 받아오기
  const lodeData = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_answer`,
      {
        pageno: selectNo,
        srch: search,
      })
      .then((res) => {
        if (res != 'ERROR') {
          console.log(res);

          setData(res);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [search, selectNo, data]);

  //상세 데이터 가져오기
  const getDetail = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/question_answer_detail`,
      {
        a_idx: etcStore.mainData.answer_selcard.a_idx,
      })
      .then((res) => {
        if (res != 'ERROR') {
          console.log(res);

          setQuestion(res[0].question);
          setNewAnswer(res[0].answer);
          setNewUrl(res[0].url);
          setNewUrlText(res[0].url_text);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [question, newAnswer, newUrl, newUrlText, etcStore.mainData.answer_selcard]);


  //답변, 링크 업데이트
  const answerEdit = useCallback(async () => {

    //기존 분류 답변 수정
    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/answer_edit`,
      {
        q_idx: etcStore.mainData.answer_selcard.q_idx,
        answer: newAnswer,
        url: newUrl,
        url_text: newUrlText,
        a_idx: etcStore.mainData.answer_selcard.a_idx,
        type: etcStore.mainData.answer_type,
      })
      .then((res) => {
        if (res != 'ERROR') {
          lodeData();
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [data, newAnswer, newUrl, newUrlText]);

  const toastMessage = () => {
    //토스트 메시지
    toast.success('성공적으로 변경되었습니다.', {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  //페이지 이동 버튼
  const PageNoBtn = ({ maxPage }) => {


    const getPageNumbers = () => {
      const numbers = [];
      const start = Math.max(1, Math.min(viewNo - 2, maxPage - 4)); // 시작 페이지
      const end = Math.min(start + 4, maxPage); // 끝 페이지

      for (let i = start; i <= end; i++) {
        numbers.push(i);
      }

      return numbers;
    };

    return (
      <Row className="justify-content-center">
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(3);

            }
          }}><AiOutlineDoubleLeft /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(viewNo - 5);
            }
          }}><GoChevronLeft /> </Button>
        {getPageNumbers().map((index) => (
          <Button
            key={index}
            className={`btn btn-sm text-break ml-3 mr-3 shadow-none border-0 `}
            style={selectNo == index ? { backgroundColor: '#3094FF', color: '#fff', alignItems: 'center' } : { backgroundColor: '#FFF', alignItems: 'center' }}
            onClick={(e) => {
              setSelectNo(index);
            }
            }
          >
            {index}
          </Button>
        ))
        }
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(viewNo + 5);
            }
          }}><GoChevronRight /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(maxPageNo - 2);
              console.log(viewNo);
            }
          }}>< AiOutlineDoubleRight /></Button>
      </Row >
    );
  }

  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <div className="w-100 d-flex justify-content-end">
          <div className="col-lg-4 text-right bg-white p-0 border rounded-lg mb-2 d-flex align-items-center">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2">
              <path d="M12.1498 10.6918H11.3819L11.1098 10.4294C12.0623 9.32133 12.6358 7.88279 12.6358 6.3179C12.6358 2.82847 9.80732 0 6.3179 0C2.82847 0 0 2.82847 0 6.3179C0 9.80732 2.82847 12.6358 6.3179 12.6358C7.88279 12.6358 9.32133 12.0623 10.4294 11.1098L10.6918 11.3819V12.1498L15.5517 17L17 15.5517L12.1498 10.6918ZM6.3179 10.6918C3.89766 10.6918 1.94397 8.73814 1.94397 6.3179C1.94397 3.89766 3.89766 1.94397 6.3179 1.94397C8.73814 1.94397 10.6918 3.89766 10.6918 6.3179C10.6918 8.73814 8.73814 10.6918 6.3179 10.6918Z" fill="#434343" />
            </svg>
            <Input
              type="text"
              className="text-dark d-inline-block border-0"
              value={search}
              placeholder="질문 카테고리 입력"
              onChange={(e) => {
                setSearch(e.target.value)
              }}
            />
          </div>
        </div>

        <Card>
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                답변 관리</h1>
              <div className=""
                style={{ color: '#727272' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div>
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                답변 관리</h2>
              <div className="   "
                style={{ color: '#727272', fontSize: '14px' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=" "
                style={{ color: '#727272', fontSize: '14px' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div>
            </div>
          </CardHeader>
          <CardBody className=" p-0 ">
            <Row className=" px-3">
              <Col className="mb-xl-0 p-0" xl="6">
                {data.map((card, cardIndex) => (
                  <Card key={cardIndex} className="shadow"
                    onClick={(e) => {
                      etcStore.updMainData({ ...etcStore.mainData, answer_selcard: card });

                      getDetail();
                    }}>
                    <CardHeader className="bg-transparent">
                      <Row className="ml-1">
                        <h3 className="mb-0">{card.question}</h3>
                      </Row>
                    </CardHeader>

                  </Card>
                ))}
              </Col>
              <Col xl="6" className="p-0">
                <Card className="" >
                  <CardBody className='p-0 ' style={{ overflowY: 'auto', minHeight: '683px' }}>
                    {(etcStore.mainData.answer_selcard != '') && (
                      <div className="mx-3 my-2">
                        <div className=" text-lg text-dark font-weight-bold mb-2">{question}</div>
                        <div>
                          <label
                            className="form-control-label text-md "
                            htmlFor="input-username"
                          >
                            답변
                          </label>
                          <Input
                            className="form-control-alternative mb-2 text-dark"
                            style={{ minHeight: '200px' }}
                            id="exampleText"
                            name="text"
                            value={newAnswer}
                            onChange={(e) => {
                              setNewAnswer(e.target.value);
                            }}
                            type="textarea"
                          />
                          <div className="d-flex">
                            <button
                              onClick={() => {
                                etcStore.updMainData({ ...etcStore.mainData, answer_type: 'answer' });
                                answerEdit();
                              }}
                              className="btn p-2 mt-1 mb-3 text-white pb-0 ml-auto"
                              style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                              저장
                            </button>
                          </div>
                        </div>
                        <div>
                          <label
                            className="form-control-label  "
                            htmlFor="input-username"
                          >
                            외부 링크
                          </label>
                          <Row >
                            <Col lg="11">
                              <Input
                                className="form-control-alternative mb-2 text-dark"
                                value={newUrl}
                                placeholder="https://"
                                onChange={(e) => setNewUrl(e.target.value)}
                              />
                            </Col>
                            <button
                              onClick={() => {

                                etcStore.updMainData({ ...etcStore.mainData, answer_type: 'url' });
                                answerEdit();
                              }}
                              className="btn text-center p-2 mt-1 mb-3 text-white pb-0 "
                              style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                              저장
                            </button>
                          </Row>
                        </div>
                        <div>
                          <label
                            className="form-control-label  "
                            htmlFor="input-username"
                          >
                            링크 대체 텍스트
                          </label>
                          <Row >
                            <Col lg="11">
                              <Input
                                className="form-control-alternative mb-2 text-dark"
                                value={newUrlText}
                                placeholder="예: 문의 바로가기"
                                onChange={(e) => setNewUrlText(e.target.value)}
                              />
                            </Col>
                            <button
                              onClick={() => {

                                etcStore.updMainData({ ...etcStore.mainData, answer_type: 'urltext' });
                                answerEdit();
                              }}
                              className="btn text-center p-2 mt-1 mb-3 text-white pb-0 "
                              style={{ backgroundColor: '#3094FF', fontWeight: 'normal', borderRadius: '5px' }}>
                              저장
                            </button>
                          </Row>
                        </div>
                      </div>
                    )}
                    {etcStore.mainData.answer_selcard == '' && (
                      <div className=" text-center mt-5"
                        style={{ color: '#757575' }}>
                        질문 분류를 선택하세요.
                      </div>
                    )}

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
          <div className="p-2 bg-white " style={{ height: '70px' }} >
            <PageNoBtn maxPage={maxPageNo} />
          </div>
        </Card>
      </Container>
    </>
  );
};

export default Answer;
